import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: ${(props) => props.columns && `${props.columns}rem`};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin: calc(var(--size) * -1.4) 0 calc(var(--size) * 1.4) 0;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 0.6rem;
  padding: 0.4rem;
  border-radius: 0.6rem;
  background-color: var(--softPurple);
`;

export const Tag = styled.span`
  font: var(--body);
`;

export const RemoveTagButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 0.6rem;
  cursor: pointer;
  background: unset;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1) rotate(180deg);
  }
`;

export const Input = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  font: var(--body);
  flex: 1;
`;

export const InfoMessage = styled.span`
  width: 100%;
  color: var(--hardRed);
  margin-top: calc(var(--size) * 0.5);
  font: var(--body);
`;

export const InputLabel = styled.span`
  width: 100%;
  font: var(--body);
  color: var(--primary);
  margin: 0;
  padding: 0.3rem;
`;

export const InputContainer = styled.div`
  padding: 1rem;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  border: calc(var(--size) * 0.1) solid var(--primary);
  border-radius: 1rem;
`;
